import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M19.286 14.584a4.192 4.192 0 00-4.179-4.178h-.643a1.917 1.917 0 00-1.607-.965H6.43A1.928 1.928 0 004.5 11.37v6.429a3.214 3.214 0 003.214 3.214h3.857a3.201 3.201 0 003.048-2.25h.488a4.192 4.192 0 004.179-4.179zm-4.179 2.25a.321.321 0 01-.321-.321v-3.857a.321.321 0 01.321-.322 2.25 2.25 0 110 4.5zM7.714 7.514a.977.977 0 00.965-.965V3.978a.964.964 0 10-1.929 0v2.571a.977.977 0 00.964.965zM11.57 7.514a.977.977 0 00.964-.965V3.978a.964.964 0 00-1.929 0v2.571a.977.977 0 00.965.965z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
